/* eslint-disable no-extend-native */
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function toValidDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function pad2(value) {
  return String(value).padStart(2, "0");
}

export function formatAppDate(value, fallback = "-") {
  const date = toValidDate(value);
  if (!date) return fallback;
  return `${pad2(date.getDate())}-${MONTHS[date.getMonth()]}-${date.getFullYear()}`;
}

export function formatAppTime(value, fallback = "-") {
  const date = toValidDate(value);
  if (!date) return fallback;

  const hours = date.getHours();
  const period = hours >= 12 ? "PM" : "AM";
  const hour12 = hours % 12 || 12;
  return `${pad2(hour12)}:${pad2(date.getMinutes())} ${period}`;
}

export function formatAppDateTime(value, fallback = "-") {
  const date = toValidDate(value);
  if (!date) return fallback;
  return `${formatAppDate(date, fallback)}, ${formatAppTime(date, fallback)}`;
}

export function installAppDateTimeFormat() {
  if (Date.prototype.__appDateTimeFormatInstalled) return;

  const nativeToLocaleDateString = Date.prototype.toLocaleDateString;
  const nativeToLocaleTimeString = Date.prototype.toLocaleTimeString;
  const nativeToLocaleString = Date.prototype.toLocaleString;

  Object.defineProperty(Date.prototype, "__appDateTimeFormatInstalled", {
    value: true,
    configurable: false,
  });

  Date.prototype.toLocaleDateString = function toLocaleDateString() {
    return toValidDate(this) ? formatAppDate(this) : nativeToLocaleDateString.call(this);
  };

  Date.prototype.toLocaleTimeString = function toLocaleTimeString() {
    return toValidDate(this) ? formatAppTime(this) : nativeToLocaleTimeString.call(this);
  };

  Date.prototype.toLocaleString = function toLocaleString() {
    return toValidDate(this) ? formatAppDateTime(this) : nativeToLocaleString.call(this);
  };
}